import React from 'react';

const ResetPasswordContext = React.createContext();

const reducer = (state, { type }) => {
  switch (type) {
    case 'setComplete':
      return { ...state, complete: true };
    default:
      throw new Error();
  }
};

const defaultState = {
  complete: false,
};

export default ResetPasswordContext;
export {
  reducer,
  defaultState,
};
